// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"499":"b749902e","795":"835bcd59"}[chunkId] + ".chunk.css";
};